exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".container-RNsi5{display:-webkit-box;display:-ms-flexbox;display:flex}.firstText-3cKtb{display:inherit;-webkit-box-align:end;-ms-flex-align:end;align-items:flex-end}", ""]);

// exports
exports.locals = {
	"container": "container-RNsi5",
	"firstText": "firstText-3cKtb"
};